export default __webpack_public_path__ + "static/media/480_store03-jp-mobile.5352da72.png";